import styled, { css } from 'styled-components';
import { AllieColors } from '../../common/color.types';

export const StyledIcon = styled.div<{ display?: string; allieColor?: AllieColors }>`
  display: ${(props) => props.display || 'block'};
  ${(props) =>
    props.allieColor &&
    css`
      color: var(--allie-color-${props.allieColor});
    `}
  .stroke-icon {
    stroke: ${(props) =>
      `var(--allie-color-${props.allieColor ? props.allieColor : 'primary-60'})`};
  }
  .fill-icon path {
    fill: ${(props) => `var(--allie-color-${props.allieColor ? props.allieColor : 'primary-60'})`};
  }
`;
